import React, { useState, useEffect, useCallback } from 'react';
import SEO from '../../components/SEO/SEO';
import axios from 'axios'
import style from './ExploreRoutines.module.css';
import StrydCardSmall from '../../components/StrydCardSmall/StrydCardSmall';
import { Link, useParams } from 'react-router-dom'
import spinner from '../../assets/Spinner.svg'
import FormInput from '../../components/FormInput/FormInput';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton';
import { toast } from 'react-toastify';
import AppLoader from '../../components/AppLoader/AppLoader';

import { useAuthUser } from '../../hooks/useAuthUser';

const API_URL = process.env.REACT_APP_API_URL;

const ExploreRoutines = () => {
	const { user, isLoaded } = useAuthUser()
	useParams();
	const DEFAULT_USER_ID = "user_2PSVExD2Jze2iGYg75qSShJe8If";


	const [routines, setRoutines] = useState(null);
	const [isRoutinesLoading, setIsRoutinesLoading] = useState(true);
	const [hasSearched, setHasSearched] = useState(false);
	const [searchInput, setSearchInput] = useState('')


	const handleSearchTtextChange = event => {
		setSearchInput(event.target.value);
	}

	const getSearchResults = () => {
		if (searchInput === '') {
			toast('Search field is empty')
			return
		}

		setHasSearched(true);
		setIsRoutinesLoading(true);
		axios.get(`${API_URL}/search/routines/${searchInput}`)
			.then(res => setRoutines(res.data))
			.catch(err => {
				console.log('error', err.message);
				setRoutines([]);
			})
			.finally(() => setIsRoutinesLoading(false));
		console.log('got results for' + searchInput)
	}


	const getRoutines = useCallback(() => {
		const userId = user?.id || DEFAULT_USER_ID; // Use default user ID if user or user.id is not available

		setIsRoutinesLoading(true);
		axios.get(`${API_URL}/recommendations/routines/${userId}`)
			.then(res => setRoutines(res.data))
			.catch(err => {
				console.log('Error fetching routines:', err.message);
				setRoutines([]);
			})
			.finally(() => setIsRoutinesLoading(false));

		console.log('get routines for userId:', userId);
	}, [user]);

	useEffect(() => {
		if (!isLoaded) return;
		getRoutines();
	}, [getRoutines, isLoaded]);

	if (!isLoaded) {
		return <AppLoader message='Loading routines...' />;
	}

	return (
		<div className={style.ExploreRoutines}>
			<SEO title="Explore routines" description="Discover community routines (stryds) based on your interests." path="/explore-routines" />
			<div className='SearchContainer'>
				<FormInput
					placeholder='Search for routines. ex: martial arts, home, HIIT, beginner'
					change={handleSearchTtextChange}
					width={window.innerWidth < 500 ? '240px' : '480px'}
					onEnter={() => getSearchResults()}
				/>

				<PrimaryButton
					text='Search'
					width='120px'
					click={() => getSearchResults()}
				/>
			</div>

			{isRoutinesLoading ? (
				<div className={style.ExploreLoadingWrap}>
					<img src={spinner} alt='' />
				</div>
			) : routines ? (
				routines.length > 0 ? ( // Check if routines array has items
					<div className={style.CardsContainer}>
						{routines.map(routine => (
							<Link
								key={`${routine.userID}-${routine?.routine?.routineName}`}
								to={`/stryd/${routine.userID}/${encodeURIComponent(routine?.routine?.routineName || 'Untitled Routine')}`}
							>
								<StrydCardSmall
									name={routine?.routine?.routineName || 'Untitled Routine'}
									time={routine?.routine?.estimatedTimeMinutes || '--'}
									creator={routine?.username || 'Unknown'}
									userID={routine.userID}
								/>
							</Link>
						))}
					</div>
				) : (
					<p>{hasSearched ? 'No routines found for that search.' : 'No routines available right now.'}</p>
				)
			) : (
				<p>No routines available right now.</p>
			)}
		</div>
	)
}

export default ExploreRoutines